module.exports = __webpack_public_path__ + "media/src/img/payment/ophone-1bf4e0a5eab258d5dfe32cfcbafede8c.png";